import React from 'react';
import { Fade } from 'react-reveal';
import SkillSection from './SkillSection';
import './Skills.css';

const Skills = () => {
  return (
    <div className='main'>
      <div className='skill-header-div'>
        <Fade bottom duration={2000} distance='20px'>
          <h1 className='skills-header'>What I Do?</h1>
        </Fade>
      </div>
      <SkillSection />
    </div>
  );
};

export default Skills;
